export default __webpack_public_path__ + "static/media/logo_stef.aa6d4465.png";